export default "__VITE_ASSET__6a160536__"